var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRrss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 26,
    viewBox: "0 0 123 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RRSS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 2078"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse 23",
    cx: 45.8501,
    cy: 12.8799,
    r: 12.395,
    fill: "#CCBD99",
    stroke: "#CCBD99",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon simple-twitter",
    d: "M51.2769 9.51386C50.8781 9.68916 50.4522 9.80858 50.0038 9.86311C50.4608 9.58777 50.8123 9.15381 50.9786 8.63603C50.55 8.88613 50.075 9.06819 49.5694 9.16958C49.1656 8.73742 48.5901 8.46704 47.9511 8.46704C46.7267 8.46704 45.7339 9.45979 45.7339 10.6828C45.7339 10.8586 45.7541 11.0275 45.7911 11.1893C43.9479 11.1023 42.3143 10.2173 41.221 8.87937C41.0286 9.20473 40.9209 9.58281 40.9209 9.99469C40.9209 10.7653 41.3129 11.4426 41.9069 11.8405C41.5432 11.8288 41.2012 11.7287 40.9028 11.5629V11.5904C40.9028 12.6651 41.6658 13.5615 42.6811 13.7656C42.495 13.8156 42.2985 13.8427 42.0971 13.8427C41.9556 13.8427 41.8199 13.8291 41.6843 13.8039C41.9686 14.684 42.7861 15.3257 43.7591 15.3437C43.002 15.9381 42.0426 16.2923 41.0092 16.2923C40.8334 16.2923 40.6581 16.2819 40.4819 16.2621C41.4684 16.8903 42.6307 17.2576 43.8875 17.2576C47.9678 17.2576 50.1963 13.8796 50.1963 10.955C50.1963 10.8608 50.1963 10.7657 50.1895 10.6711C50.6226 10.3606 51.0007 9.9681 51.2981 9.52288L51.2769 9.51386Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 2077"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse 24",
    cx: 78.01,
    cy: 12.8799,
    r: 12.395,
    fill: "#CCBD99",
    stroke: "#CCBD99",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon ionic-logo-instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2948",
    d: "M80.5223 8.59044C81.0952 8.59044 81.6385 8.81746 82.0493 9.22557C82.4602 9.63367 82.6845 10.1796 82.6845 10.7526V15.0768C82.6845 15.6498 82.4575 16.193 82.0493 16.6038C81.6412 17.0147 81.0952 17.239 80.5223 17.239H76.1978C75.6248 17.239 75.0815 17.012 74.6707 16.6038C74.2599 16.1957 74.0355 15.6498 74.0355 15.0768V10.7526C74.0355 10.1796 74.2626 9.63637 74.6707 9.22557C75.0788 8.81476 75.6248 8.59044 76.1978 8.59044H80.5223ZM80.5223 7.72559H76.1978C74.5329 7.72559 73.1707 9.08773 73.1707 10.7526V15.0768C73.1707 16.7417 74.5329 18.1038 76.1978 18.1038H80.5223C82.1872 18.1038 83.5494 16.7417 83.5494 15.0768V10.7526C83.5494 9.08773 82.1872 7.72559 80.5223 7.72559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2949",
    d: "M81.1709 10.7527C80.8114 10.7527 80.5222 10.4635 80.5222 10.104C80.5222 9.74457 80.8114 9.45538 81.1709 9.45538C81.5277 9.45538 81.8196 9.74457 81.8196 10.104C81.8196 10.4635 81.5277 10.7527 81.1709 10.7527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2950",
    d: "M78.3601 11.1852C79.3141 11.1852 80.0899 11.9609 80.0899 12.9149C80.0899 13.869 79.3141 14.6446 78.3601 14.6446C77.406 14.6446 76.6303 13.869 76.6303 12.9149C76.6303 11.9609 77.406 11.1852 78.3601 11.1852ZM78.3601 10.3204C76.9276 10.3204 75.7654 11.4825 75.7654 12.9149C75.7654 14.3473 76.9276 15.5095 78.3601 15.5095C79.7925 15.5095 80.9547 14.3473 80.9547 12.9149C80.9547 11.4825 79.7925 10.3204 78.3601 10.3204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 2076"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse 25",
    cx: 110.17,
    cy: 12.8799,
    r: 12.395,
    fill: "#CCBD99",
    stroke: "#CCBD99",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon metro-linkedin",
    d: "M113.483 7.06848H106.2C105.187 7.06848 104.358 7.89737 104.358 8.91046V16.1927C104.358 17.2058 105.187 18.0347 106.2 18.0347H113.483C114.496 18.0347 115.325 17.2058 115.325 16.1927V8.91046C115.325 7.89737 114.496 7.06848 113.483 7.06848ZM108.47 15.9785H107.1V11.1808H108.47V15.9785ZM107.785 10.4954C107.406 10.4954 107.1 10.1886 107.1 9.81004C107.1 9.43151 107.406 9.12465 107.785 9.12465C108.164 9.12465 108.47 9.43151 108.47 9.81004C108.47 10.1886 108.164 10.4954 107.785 10.4954ZM113.268 15.9785H111.898V13.237C111.898 12.8585 111.591 12.5516 111.212 12.5516C110.834 12.5516 110.527 12.8585 110.527 13.237V15.9785H109.156V11.1808H110.527V12.0319C110.809 11.6435 111.242 11.1808 111.726 11.1808C112.578 11.1808 113.268 11.948 113.268 12.8943V15.9785Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 2079"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse 22",
    cx: 13.69,
    cy: 12.88,
    r: 12.395,
    fill: "#CCBD99",
    stroke: "#CCBD99",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon zocial-facebook",
    d: "M11.0037 13.0604V10.9295H12.7225V9.85797C12.7225 9.0842 12.9732 8.4262 13.4754 7.88293C13.9775 7.34 14.586 7.06836 15.2999 7.06836H17.0072V9.19962H15.2999C15.1886 9.19962 15.0882 9.26099 14.9989 9.38374C14.9097 9.50648 14.865 9.65712 14.865 9.83565V10.9292H17.0072V13.0601H14.8647V18.2268H12.7221V13.0604H11.0037Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrss);
export default __webpack_public_path__ + "static/media/rrss.6163803480c16648888ff92ca2b6bbaa.svg";
export { ForwardRef as ReactComponent };